import React from 'react';
import {inject, observer} from 'mobx-react';
import {AxlCheckbox, AxlReselect} from 'axl-reactjs-ui';


// Styles
import styles from './styles';
import AxlSearchBox from "../../AxlSearchBox";
import InsuranceCoverage from "./components/InsuranceCoverage";
import {Container, FormControlLabel, Grid, Radio, RadioGroup, Typography, withStyles} from "@material-ui/core";
import moment from "moment";
import AxlDatePicker from "../../AxlDatePicker";
import {CLAIM_TYPES} from "../../../constants/claimTypes";
import {LoadingOverlay} from "../../LoadingOverlay";
import ClientInfo from "./components/ClientInfo";
import {cloneDeep} from "lodash";

const {LOSS, DAMAGE} = CLAIM_TYPES;


class CreateClaimForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query: "",
            searched: false,
        }
    }

    componentDidMount() {
        const {insuranceStore} = this.props;
        insuranceStore.reset();
    }

    changeSearch = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        this.setState({
            query: value,
        });
    };

    onSearchEnter = (e) => {
        const {insuranceStore, userStore} = this.props;
        const {claimForm} = insuranceStore;
        const {client} = userStore;

        insuranceStore.getCoverage(this.state.query);
        claimForm.setField('address', cloneDeep(client?.address));
        claimForm.setField('payeeFullName', cloneDeep(client?.company));
    }

    clearSearch = (e) => {
        const {insuranceStore} = this.props;
        this.setState({
            query: "",
            searched: false,
        });
        insuranceStore.clearCoverage();
    };

    handleChangeDate = (value) => {
        const {insuranceStore} = this.props;
        const {claimForm} = insuranceStore;

        if (!value) {
            claimForm.setField('lossDate', null)
            return;
        }

        const formattedLossDate = moment(value).format('YYYY-MM-DD')
        claimForm.setField('lossDate', formattedLossDate)
    };

    handleChangeClaimType = (e) => {
        const {insuranceStore} = this.props;
        const {claimForm} = insuranceStore;
        const value = e.target.value;
        claimForm.setField('claimType', value);
        claimForm.setField('claimDescription', null);
    }


    render() {
        const preFilled = false;
        const {insuranceStore, classes} = this.props;
        const {coverage, claimDescriptionOptions, claimForm, submitting, loading} = insuranceStore;
        const {createClaimStep, isOneStepClaim} = insuranceStore;
        const isRepairable = claimForm.getField("isRepairable", "yes");
        const selectedClaimDescription = claimForm.getField("claimDescription", null);
        const isAgreementChecked = claimForm.getField("agreeToTerms", false);
        const lossDate = claimForm.getField("lossDate", null);
        const claimType = claimForm.getField("claimType", null);
        const filteredClaimDescriptionOptions = claimDescriptionOptions.filter((option) => {
            return option.type.includes(claimType?.toLowerCase())
        });
        const claimDescriptionValue = selectedClaimDescription ? filteredClaimDescriptionOptions.find((option) => option.value == selectedClaimDescription) : null;
        const disabled = !coverage || submitting || loading;

        return (
            <Container className={classes.container}>
                {(submitting || loading) && <LoadingOverlay color="#887fff"/>}
                { !isOneStepClaim &&
                    <Grid item>
                        <div className={classes.process}>
                            <div className={classes.processor}>
                                {['Submission', 'Review'].map((value, index) =>
                                    <div className={classes.processorItem} key={index}>
                                        <div
                                            className={`${classes.processBar} ${createClaimStep === (index + 1) ? 'active' : createClaimStep > index ? 'success' : (preFilled && [1, 2].indexOf(index) !== -1) ? 'pre-fill' : ''}`}
                                        />
                                        <div
                                            className={`${classes.processorStatus} ${createClaimStep === (index + 1) ? 'active' : createClaimStep > index ? 'success' : ''}`}>{value}</div>
                                        {(index + 1) !== 2 &&
                                            <div className={`${classes.processLine} ${createClaimStep > (index + 1) ? 'success' : ''}`}/>}
                                    </div>)}
                            </div>
                        </div>
                    </Grid>
                }
                {createClaimStep === 1 &&
                    <>
                        <Grid item className={classes.searchBox} xs={12}>
                                <AxlSearchBox
                                    placeholder={"Search Shipment ID"}
                                    onChange={this.changeSearch}
                                    style={{width: "100%", height: "46px", flex: 1}}
                                    onEnter={this.onSearchEnter}
                                    value={this.state.query}
                                    clearValue={this.clearSearch}
                                    fullWidth
                                />
                        </Grid>

                        <Grid container>
                            <Grid item xs={12}>
                                <InsuranceCoverage coverage={coverage}/>
                            </Grid>
                        </Grid>


                        <Grid container className={classes.row}>
                            <Grid item xs={12}>
                                <Typography className={classes.subTitle}>Failed Dropoff Date</Typography>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.row}>
                            <Grid item xs={12}>
                            <AxlDatePicker
                                label=""
                                handleChange={this.handleChangeDate}
                                format="MM/DD/yyyy"
                                value={lossDate ? moment(lossDate) : null}
                                variant="inline"
                                inputVariant="outlined"
                                size="small"
                                disableToolbar={true}
                                fullWidth
                                disabled={disabled}
                                maxDate={moment()}
                            />
                            </Grid>
                        </Grid>
                        <Grid container className={classes.row}>
                            <Grid item xs={12}>
                            <Typography className={classes.subTitle}>Claim Type</Typography>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.row}>
                            <Grid item className={styles.claimType}>
                                <RadioGroup name="claimType" value={claimType} onChange={this.handleChangeClaimType}
                                            row>
                                    <FormControlLabel value={LOSS} control={<Radio color="primary"/>}
                                                      label={"Loss"} disabled={disabled}/>
                                    <FormControlLabel value={DAMAGE} control={<Radio color="primary"/>}
                                                      label={"Damage"} disabled={disabled}/>
                                </RadioGroup>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} className={classes.controlSelect} >
                            <Typography className={classes.subTitle}>{`Claim Description`}</Typography>
                            <AxlReselect
                                disabled={disabled}
                                name='Claim Description'
                                value={claimDescriptionValue}
                                onChange={(e) => {
                                    claimForm.setField('claimDescription', e.value);
                                }}
                                placeholder={'Select description here'} theme={`main`}
                                options={filteredClaimDescriptionOptions}/>
                            </Grid>
                        </Grid>
                        {claimType === DAMAGE &&
                            <>
                                <Grid container className={classes.row}>
                                    <Typography className={classes.subTitle}>Repairable?</Typography>
                                    <Grid item className={classes.Field}>
                                        <RadioGroup name="isRepairable" value={isRepairable} onChange={e => {
                                            claimForm.setField(e.target.name, e.target.value)
                                        }} row disabled={disabled}>
                                            <FormControlLabel value={"yes"} control={<Radio color="primary"/>}
                                                              label={"Yes"}/>
                                            <FormControlLabel value={"no"} control={<Radio color="primary"/>}
                                                              label={"No"}/>
                                        </RadioGroup>
                                    </Grid>
                                </Grid>
                            </>
                        }
                        {
                            isOneStepClaim &&
                            <Grid container className={classes.row}>
                                <Grid item>
                                    <AxlCheckbox name={`agreeToTerms`}
                                                 checked={isAgreementChecked} onChange={() => {
                                        claimForm.setField("agreeToTerms", !isAgreementChecked)
                                    }}
                                                 color={`green`}
                                                 disabled={disabled}
                                                 theme={`secondary`}>{`I acknowledge I have read the Terms of Insurance`}
                                    </AxlCheckbox>
                                </Grid>
                            </Grid>
                        }
                    </>
                }
                {createClaimStep === 2 &&
                    <>
                        <Grid container className={classes.row}>
                            <Grid item xs={12}>
                                <ClientInfo/>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.row}>
                            <Grid item>
                                <AxlCheckbox name={`agreeToTerms`}
                                             checked={isAgreementChecked} onChange={() => {
                                    claimForm.setField("agreeToTerms", !isAgreementChecked)
                                }}
                                             color={`green`}
                                             disabled={disabled}
                                             theme={`secondary`}>{`I acknowledge I have read the Terms of Insurance`}
                                </AxlCheckbox>
                            </Grid>
                        </Grid>
                    </>
                }
            </Container>
        );
    }
}

export default withStyles(styles)(inject('insuranceStore', 'userStore')(observer(CreateClaimForm)));
